import React from 'react';
import { Box, DialogTitle, Typography } from '@mui/material';

/** Dialog header: tinted icon, title and one-line help text. */
export const DialogHeader = ({ icon, title, subtitle }) => (
  <DialogTitle
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      pb: 1.5,
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: '12px',
        display: 'grid',
        placeItems: 'center',
        color: 'primary.main',
        bgcolor: 'rgba(77, 108, 217, 0.12)',
      }}
    >
      {icon}
    </Box>
    <Box>
      <Typography variant="h6" sx={{ lineHeight: 1.2 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  </DialogTitle>
);

/** Small caps label above a group of fields. */
export const SectionLabel = ({ children }) => (
  <Typography
    variant="caption"
    sx={{
      display: 'block',
      mb: 0.75,
      fontWeight: 700,
      letterSpacing: 0.6,
      textTransform: 'uppercase',
      color: 'text.secondary',
    }}
  >
    {children}
  </Typography>
);
